<oneshot-modal>
    <div id="{ props.modalId }" class="modal js-modal">
        <div class="modal__bg js-modal-close"></div>
        <div class="modal__content modal_filter">
            <div class="modal__content_inner">
                <h2 class="modal_title">カウント追加購入</h2>
                
                <form action="" class="form_filter">
                    
                    <div class="bnr_plan is-selected">
                        <div class="radio_wrap plan">
                            <input type="radio" name="shot-select" value="{state.plan.name}" class="radio-input" checked="checked">
                            <label for="plan-plus100" class="radio_label">{state.plan.name}</label>
                        </div><!--/.radio_wrap-->
                        
                        <dl class="bnr_plan_detail">
                            <dt class="bnr_plan_detail-title">ご利用可能回数</dt>
                            <dd class="bnr_plan_detail-content"><span class="emphasis">+{state.plan.tickets}</span></dd>
                            <dt class="bnr_plan_detail-title">金額</dt>
                            <dd class="bnr_plan_detail-content">+{state.plan.price.toLocaleString()}円 (税込)</dd>
                        </dl>
                    </div><!--/.bnr_plan-->
                    <p class="notice align-r">※追加カウント、追加料金は今月分にのみ加算されます。<br>※解析回数は翌月への繰り越しはありません。</p>
                    
                </form><!--/.form_filter	-->   
                
                <button class="button button-primary" type="button" value="追加購入する" onclick={(e)=> buy(e)}><a href="#">追加購入する</a></button>
            </div><!--/.modal__content_inner-->
            <a  style="cursor:pointer" class="btn_close_modal js-modal-close" onclick="{ onClose }"><img src="/assets/img/common/icn_close_modal.svg" alt="閉じる"></a>
        </div><!--modal__content-->
    </div><!--modal-->
  <script>
    import { api as SettingOneshotApi } from "@model/setting-oneshot.js";

    export default {
        state: {
            plan: {
                name: "",
                price: 0,
                tickets: 0
            }
        },
        onMounted(){
            SettingOneshotApi.on('fetched:items', (data) => {
                this.state.plan = data;
                this.update()
            });
            SettingOneshotApi.on('bought', (success, data) => {
                if (!success) {
                    console.log(data);
                    alert(data);
                    return;
                }
                if (data.href) {
                    this.onClose();
                    location.href = data.href;
                    return;
                };
            });
            SettingOneshotApi.items();
        },
      onClose(e) {
        window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
      },
      buy(e) {
          SettingOneshotApi.buy();
      }
    };
  </script>
</oneshot-modal>
